// Canonical employee status handling for consistent UI

export type EmployeeStatusValue =
  | "active"
  | "inactive"
  | "applicant"
  | "cobra"
  | "deceased"
  | "leave of absence"
  | "pending_activation"
  | "retired"
  | "terminated"
  | "test";

export const EMPLOYEE_STATUS_OPTIONS: { value: EmployeeStatusValue; label: string }[] = [
  { value: "pending_activation", label: "Pending Activation" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "applicant", label: "Applicant" },
  { value: "cobra", label: "COBRA" },
  { value: "deceased", label: "Deceased" },
  { value: "leave of absence", label: "Leave of Absence" },
  { value: "retired", label: "Retired" },
  { value: "terminated", label: "Terminated" },
  { value: "test", label: "Test" },
];

const statusAliasMap: Record<string, EmployeeStatusValue> = {
  active: "active",
  inactive: "inactive",
  applicant: "applicant",
  cobra: "cobra",
  deceased: "deceased",
  "leave of absence": "leave of absence",
  leave: "leave of absence",
  pending_activation: "pending_activation",
  "pending activation": "pending_activation",
  pending: "pending_activation",
  retired: "retired",
  terminated: "terminated",
  test: "test",
};

export function normalizeStatus(raw?: string | null): EmployeeStatusValue | undefined {
  if (!raw) return undefined;
  const key = String(raw).trim().toLowerCase();
  return statusAliasMap[key];
}

export function formatStatus(raw?: string | null): string {
  const norm = normalizeStatus(raw);
  if (!norm) return raw || "Not provided";
  const opt = EMPLOYEE_STATUS_OPTIONS.find(o => o.value === norm);
  return opt ? opt.label : raw || "Not provided";
}
